import { put } from "redux-saga/effects";

import { apiFetch } from "common/utilities";
import { logger } from "common/utilities/logger";
import { approveKnowledgeFulfilled, approveKnowledgeRejected } from "domains/pinAddReject/actions";
import type { ApproveKnowledge } from "domains/pinAddReject/actionTypes";

export function* approveKnowledgeSaga(action: ApproveKnowledge) {
  const { knowledgeId } = action.meta;

  try {
    yield apiFetch("knowledge/approve", {
      method: "PUT",
      body: {
        knowledge_id: knowledgeId,
      },
    });
    yield put(approveKnowledgeFulfilled(action.meta));
    action.meta.onSuccess?.();
  } catch (error) {
    logger.error("[approveKnowledgeSaga] Error occurred while approving knowledge", error);
    yield put(approveKnowledgeRejected({ ...action.meta, logoutOnAuthError: true }));
  }
}
